/* eslint react-hooks/exhaustive-deps: "warn" */

import { type ReactNode, type CSSProperties } from 'react';

import cn from 'classnames';

import { useInt } from 'hooks/useInt';

import { Image } from 'ui/atoms/Image';
import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { InfiniteScroller } from 'ui/molecules/InfiniteScroller/InfiniteScroller';

import styles from './OurCustomersV2.module.scss';

interface Props {
  description?: ReactNode;
  hasBackground?: boolean;
  background?: string;
  className?: string;
  scrollerBackgroundColor?: string;
}

export const logos = [
  'allianz',
  'uber',
  'amazon',
  'statista',
  'lseg',
  'persona',
  'zeizz',
  'sap',
  'schneider',
  'kroll',
  'experian',
  'quantifind',
  'bdo',
];

const logoElements = logos.map((logo, idx) => (
  <div key={`${logo}-${idx}`} className={cn(styles.logo, { [styles.logoEmblem]: logo === 'zeizz' })}>
    <Image width={70} height={24} src={`img/customers/${logo}.svg`} alt={`${logo} logo`} />
  </div>
));

const GRADIENT_BG = 'linear-gradient(360deg, #f0f5f9 0%, rgba(245, 249, 252, 0) 100%)';

export const OurCustomersV2 = ({
  description,
  hasBackground = true,
  background,
  className,
  scrollerBackgroundColor = '#fff',
}: Props) => {
  const { t } = useInt();
  const resolvedBackground = background ?? (hasBackground ? GRADIENT_BG : undefined);

  return (
    <section
      className={cn(styles.section, className)}
      style={resolvedBackground ? ({ background: resolvedBackground } as CSSProperties) : undefined}
    >
      <div className={styles.container}>
        <TitleBlock title={t('Trusted by compliance, risk and data teams at')} description={description} />
      </div>

      <div className={styles.scrollerWrapper}>
        <InfiniteScroller
          items={logoElements}
          slideWidth={170}
          slideHeight={48}
          slideGap={40}
          animationDuration={26}
          backgroundColor={scrollerBackgroundColor}
        />
      </div>
    </section>
  );
};
